import { Loggable } from 'app/utils/logging/loggable';

import { SceneService } from '../services/scene.service';
import { ConnectionStatus } from '../social-pixi-canvas/player-components/player.state';

export default class ParticipantRtcStats extends Loggable {
  private videoBytesReceivedLastValue = -1;
  private videoBytesReceivedStuckCount = 0;
  private audioBytesReceivedLastValue = -1;
  private audioBytesReceivedStuckCount = 0;
  private bytesReceivedStuckCountLimit = 10;
  private bytesReceivedStuckCountWarning = 5;
  private videoNotFoundLimit = 7;
  private audioNotFoundLimit = 7;

  public constructor(
    private userId: string,
    private sceneService?: SceneService,
  ) {
    super();
    this.setDisplayName('ParticipantRtcStats');
  }

  public isVideoStuck(videoStats: RTCStatsReport, userId?: string, firstName?: string): boolean {
    if (!userId) {
      return false;
    }
    let videoReportFound = false;
    let stuck = false;
    videoStats.forEach((report) => {
      if (report.type === 'inbound-rtp' && report.kind === 'video') {
        videoReportFound = true;
        // BytesReceived is not growing
        if (report.bytesReceived > 0 && report.bytesReceived === this.videoBytesReceivedLastValue) {
          this.videoBytesReceivedStuckCount++;
          this.warn(
            `RTC Stats - VIDEO Error #${this.videoBytesReceivedStuckCount}`,
            userId,
            firstName,
            report.bytesReceived,
          );
          if (
            this.videoBytesReceivedStuckCount > 0 &&
            this.videoBytesReceivedStuckCount < this.bytesReceivedStuckCountWarning &&
            this.sceneService
          ) {
            this.sceneService.sceneManager?.setPlayerConnectionStatus(this.userId, ConnectionStatus.INTERMITTENT);
          }
          if (this.videoBytesReceivedStuckCount >= this.bytesReceivedStuckCountWarning && this.sceneService) {
            this.sceneService.sceneManager?.setPlayerConnectionStatus(this.userId, ConnectionStatus.DISCONNECTED);
          }
          // If its the 10th time not growing
          if (this.videoBytesReceivedStuckCount >= this.bytesReceivedStuckCountLimit) {
            this.videoBytesReceivedStuckCount = 0;
            this.error('RTC Stats - VIDEO got Stuck', userId);
            stuck = true;
          }
        } else {
          this.videoBytesReceivedLastValue = report.bytesReceived;
          this.videoBytesReceivedStuckCount = 0;
        }
      }
    });
    if (!videoReportFound) {
      const rtcReports: RTCStatsReport[] = [];
      videoStats.forEach((report) => rtcReports.push(report));
      this.warn('RTC Stats - VideoReport NOT FOUND', rtcReports, userId);
      if (--this.videoNotFoundLimit < 0) {
        return true;
      }
    }
    return stuck;
  }

  public isAudioStuck(audioStats: RTCStatsReport, userId?: string, firstName?: string): boolean {
    let stuck = false;
    // Calculate audio stats
    let audioReportFound = false;
    audioStats.forEach((report) => {
      if (report.type === 'inbound-rtp' && report.kind === 'audio') {
        audioReportFound = true;

        // BytesReceived is not growing
        if (report.bytesReceived > 0 && report.bytesReceived === this.audioBytesReceivedLastValue) {
          this.audioBytesReceivedStuckCount++;
          this.warn(
            `RTC Stats - AUDIO Error #${this.audioBytesReceivedStuckCount}`,
            userId,
            firstName,
            report.bytesReceived,
          );
          // If its the 5th time not growing
          if (this.audioBytesReceivedStuckCount >= this.bytesReceivedStuckCountLimit) {
            this.audioBytesReceivedStuckCount = 0;
            this.error('RTC Stats - AUDIO got Stuck', userId);
            stuck = true;
          }
        } else {
          this.audioBytesReceivedLastValue = report.bytesReceived;
          this.audioBytesReceivedStuckCount = 0;
        }
      }
    });
    if (!audioReportFound) {
      const rtcReports: RTCStatsReport[] = [];
      audioStats.forEach((report) => rtcReports.push(report));
      this.warn('RTC Stats - AudioReport NOT FOUND', rtcReports, userId);
      if (--this.audioNotFoundLimit < 0) {
        return true;
      }
    }
    return stuck;
  }

  public destroy(): void {
    this.videoBytesReceivedLastValue = -1;
    this.videoBytesReceivedStuckCount = 0;
    this.audioBytesReceivedLastValue = -1;
    this.audioBytesReceivedStuckCount = 0;
  }
}
